﻿import jQuery from 'jquery';
import '../lib/bootstrap.css';
import notify from './lib/notifications';
window.notify = notify;
import 'notyf/notyf.min.css';
import 'flatpickr/dist/flatpickr.min.css';
import '@glidejs/glide/dist/css/glide.core.min.css';
import '../less/style.less';
import './utilities';
import './lib/countdown';
import './lib/plans-tabs';
import './lib/plan-cards-slider';
import './lib/content-tabs';
import './lib/dialog';
import './lib/dropdown';
import './lib/collapse';
import './lib/tooltip';
import './lib/coverage-check';
import './lib/faq-accordion';
import './lib/bundle-builder';
import './lib/product-tabs';
import './lib/product-quantity';
import './lib/account-type-toggle';
import './lib/document-type-toggle';
import './lib/account-personal-info-toggle';
import './lib/account-personal-info-validation';
import './lib/password-toggle';
import './lib/account-tabs';
import './lib/ship-to-different-address';
import './lib/payment-bank-transfer';
import Account from './account';
import Validation from './validation';
import Verification from './document_verification';
import DatePicker from './lib/datepicker';
import './lib/date-picker';
import './lib/marketing-popup';

// Sync jQuery plugins from bundled jQuery to window.jQuery.
// All plugin imports above register on the bundled copy; we copy them
// so that modules using window.jQuery (e.g. account.js, validation.js) see them too.
if (window.jQuery && window.jQuery !== jQuery) {
    Object.keys(jQuery.fn).forEach(function (key) {
        if (!window.jQuery.fn[key]) {
            window.jQuery.fn[key] = jQuery.fn[key];
        }
    });
    Object.keys(jQuery).forEach(function (key) {
        if (typeof jQuery[key] === 'function' && !window.jQuery[key]) {
            window.jQuery[key] = jQuery[key];
        }
    });
}

(function ($) {
    function ThemeScript() {
        let body = $('body');
        let html_tag = $('html');
        let wind = $(window);
        let self = this;

        function initOrderBtn() {
            jQuery('.order-product').click(function (e) {
                e.preventDefault();
                var $this = jQuery(this);
                jQuery.ajax('/wp/wp-admin/admin-ajax.php', {
                    method: 'POST',
                    data: {
                        action: 'amenities_add_to_cart',
                        product_id: $this.data('product-id'),
                    },
                    success: function (data) {
                        window.location.replace($this.attr('href'));
                    },
                });
            });
        }

        function initShowHidePassword() {
            jQuery('i[data-target="show-password"]').click(function () {
                var input = $(this).closest('.input-group').find('input.form-control, input.form-field__control');

                if (input[0].type === 'password') {
                    input[0].type = 'text';
                    $(this).removeClass('fa-eye-slash').addClass('fa-eye');
                } else {
                    input[0].type = 'password';
                    $(this).removeClass('fa-eye').addClass('fa-eye-slash');
                }
            });
        }

        function initChooseNationalityEvent() {
            jQuery('input[name="nationality"]').change(function (e) {
                if (jQuery(this).val() === 'rest_of_the_world') {
                    jQuery('.nationality-swiss').addClass('d-none');
                    jQuery('.nationality-rest').removeClass('d-none').children().first().click();
                } else {
                    jQuery('.nationality-rest').addClass('d-none');
                    jQuery('.nationality-swiss').removeClass('d-none').children().first().click();
                }
            });
        }

        function initChoosePlanEvent() {
            $('.months .month input').click(function () {
                var input = $(this);
                var id = input.attr('id');
                var selector = 'month' + id;

                if (input.prop('checked')) {
                    $('#' + selector).val('active');
                    $('.' + selector).html('Active');
                } else {
                    $('#' + selector).val('stand_by');
                    $('.' + selector).html('Stand by');
                }
            });
        }

        function initChooseUserFisrstStep() {
            jQuery('input[name="user_type_first_step"]').change(function (e) {
                if (jQuery(this).val() === 'registered-user') {
                    jQuery('.new-user').addClass('d-none');
                    jQuery('.registered-user').removeClass('d-none').children().first().click();
                } else {
                    jQuery('.registered-user').addClass('d-none');
                    jQuery('.new-user').removeClass('d-none').children().first().click();
                }
            });
        }

        function initVerification() {
            jQuery('#verify').click(function () {
                var verification = new Verification();
                verification.init();
            });
        }

        function initAccount() {
            var account = new Account();
            account.init();
        }

        function initValidation() {
            var validation = new Validation();
            validation.init();
        }

        function initMask() {
            jQuery(document).ready(function ($) {
                var mask = require('jquery-mask-plugin');
                $.mask = mask;
                window.mask = mask;
                var inputTel = jQuery('input[type="tel"]');
                if (inputTel) {
                    inputTel.mask('0#');
                    // inputTel.mask('(000) 000 00 00');
                }
                var inputPostcode = jQuery('input[name="postcode"]');
                if (inputPostcode) {
                    inputPostcode.mask('0#');
                }
                // var inputAtidHousen = jQuery('input[name="atid_housen"]');
                // if (inputAtidHousen) {
                //     inputAtidHousen.mask('0#');
                // }
            });
        }

        function initQntProductCart() {
            $('.qnt .active').click(function () {
                let qnt_action = $(this).attr('data-action');
                let qnt_key = $(this).attr('data-key');
                if (!qnt_action) {
                    return false;
                }

                $.ajax({
                    url: twf.ajax_url,
                    method: 'POST',
                    dataType: 'json',
                    data: {
                        action: 'update_product_qnt',
                        qnt_action: qnt_action,
                        qnt_key: qnt_key,
                    },
                    beforeSend: function () {
                        window.window.jQuery.LoadingOverlay('show');
                    },
                    success: function (d) {
                        window.location.reload();
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        console.log(errorThrown);
                        window.window.jQuery.LoadingOverlay('hide');
                    },
                });
            });
        }

        function initPlansAnchors() {
            jQuery(document).ready(function ($) {
                if (jQuery("header li a.nav-link[href='/#plans']")) {
                    if (jQuery.inArray(window.location.pathname, ['/de/', '/en/', '/it/', '/fr/']) >= 0) {
                        var href = '/#plans'.replace('/', '');
                        jQuery("header li a.nav-link[href='/#plans']").attr('href', href);
                    }
                }

                if (jQuery("footer a.footer_link[href='/#plans']")) {
                    if (jQuery.inArray(window.location.pathname, ['/de/', '/en/', '/it/', '/fr/']) >= 0) {
                        var href = '/#plans'.replace('/', '');
                        jQuery("footer a.footer_link[href='/#plans']").attr('href', href);
                    }
                }
            });
        }

        function initChangeLanguage() {
            jQuery('.change-language').click(function (e) {
                e.preventDefault();

                var href = jQuery(this).attr('href');
                var locale = jQuery(this).data('locale');

                utilities.setCookie('language', locale);
                utilities.setCookie('language', locale, '/wp/');

                location.replace(href);
            });
        }

        function initDatepicker() {
            var d = new DatePicker();

            d.createDatePicker('.bootstrap-datepicker #atid_dob', {
                changeMonth: true,
                changeYear: true,
                dateFormat: 'dd.mm.yy',
                maxDate: new Date(),
                yearRange: '-90:+0',
            });

            d.createDatePicker('.bootstrap-datepicker #subscription_start_date', {
                changeMonth: true,
                changeYear: true,
                dateFormat: 'dd.mm.yy',
                minDate: new Date(),
                maxDate: '+3m',
            });

            // The redesigned checkout's #subscription_start_date/#twf_date_of_birth
            // (woocommerce/checkout/form-billing.php) and the Personal Info tab's
            // #date_of_birth (templates/account.twig) use flatpickr instead — see ./lib/date-picker.
        }

        function initEcommerceDataThankYouPage() {
            if (twf.order_received_id) {
                var ordernumber = twf.order_received_id;

                let data_values = {
                    action: 'amenities_get_order_info_by_id',
                    security: twf.account_nonce,
                    ordernumber: ordernumber,
                };

                $.ajax({
                    url: twf.ajax_url,
                    method: 'POST',
                    dataType: 'json',
                    data: data_values,
                    success: function (d) {
                        if (d.status == 'success') {
                            dataLayer.push({
                                cartContent: {
                                    totals: {
                                        total: d.data.total_price,
                                    },
                                    items: d.data.items,
                                },
                                google_tag_params: {
                                    cartContent: {
                                        totals: {
                                            total: d.data.total_price,
                                        },
                                        items: d.data.items,
                                    },
                                },
                                ecommerce: {
                                    currencyCode: 'CHF',
                                    purchase: {
                                        actionField: {
                                            id: ordernumber,
                                        },
                                    },
                                },
                            });
                        }
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        renderMessage(twf.products_error_msg, 'alert-danger', self._messages);
                    },
                });
            }
        }

        function toogleCompanyField() {
            let companyCheckbox = $('#open-company-account');
            let companyInput = $('#company-account-field');

            companyInput.prop('hidden', !companyCheckbox.is(':checked'));

            companyCheckbox.on('click', function () {
                companyInput.prop('hidden', !$(this).is(':checked'));
                if ($(this).is(':checked')) {
                    companyInput.val('');
                }
            });
        }

        self.run = function () {
            initShowHidePassword();
            initOrderBtn();
            initChooseUserFisrstStep();
            initChooseNationalityEvent();
            initChoosePlanEvent();
            initVerification();
            initAccount();
            initValidation();
            initMask();
            initQntProductCart();
            initPlansAnchors();
            initChangeLanguage();
            initDatepicker();
            initEcommerceDataThankYouPage();
            toogleCompanyField();
        };
    }

    $(function () {
        let ts = new ThemeScript();
        ts.run();
    });
})(jQuery);
